import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";

const ChildHeaderCard = ({ icon, title, value, width }) => {
  const location = useLocation();

  const isScore = title.toLowerCase().includes("score");

  return (
    <Box
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: ".65vw",
        minWidth: width,
        maxWidth: width,
        height: location.pathname === "/order" ? "2.5vw" : "3vw",
        background: "#0D0D0D",
        borderRadius: ".25vw",
        whiteSpace: "nowrap",
      }}
    >
      <Box sx={{ height: "3vh", display: "flex", alignItems: "center" }}>
        {icon}
      </Box>
      <Typography
        fontSize={".75vw"}
        fontWeight={500}
        fontFamily={"Karla"}
        color={"#FCFAFA"}
      >
        {title}
      </Typography>
      <Typography
        fontSize={"1vw"}
        fontWeight={500}
        fontFamily={"Poppins"}
        sx={
          isScore
            ? {
                background: "linear-gradient(to bottom, #50C878, #093317)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }
            : {}
        }
      >
        {value}
      </Typography>
    </Box>
  );
};

export default ChildHeaderCard;
